module.exports = __webpack_public_path__ + "static/img/アセット 15@2x.595335d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 15@2x.png
// module id = qtFJ
// module chunks = 1